import ctfynewspaper from '../../media/ctfynewspaper.jpg';
import tlwtgerman from '../../media/book6german.jpg';
import ctfycanada from '../../media/book8canada.jpg';
import podcastImage from '../../media/charlielovett.jpg';
import idoatcanada from '../../media/book9canada.jpg';
import tsirscanada from '../../media/book10canada.jpg';
import event325 from '../../media/tsirsjanebookshop.jpg';
import domesticaImage from '../../media/domestica.png';
import canadalist from '../../media/canadabestseller.png';

export const newsImageMap = {
  tsirscover: tsirscanada,
  janetsirs: event325,
  domestica: domesticaImage,
  canadalist: canadalist,
  idoatcanada: idoatcanada,
  ctfycanada: ctfycanada,
  podcastImage: podcastImage,
  tlwtgerman: tlwtgerman,
  ctfynewspaper: ctfynewspaper,
};
